import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class EmpregadoService extends CRUDService{
    constructor() {
        super("empregado");
    }

    getByCPF(cpf) {
        return http.get("/"+this.serviceName+"/cpf/"+cpf)
    }

    getByMatricula(matricula) {
        return http.get("/"+this.serviceName+"/matricula/"+matricula)
    }

    getEbsByMatricula(matricula) {
        return http.get(`/empregado/ebs/matricula/${matricula}`)
    }

/*     getByIdAprovador(idAprovador) {
        return http.get(`/empregado/personid/${idAprovador}`);
    } */

    filtrarGestoresPorNh(prefixoNome){
        return http.get(`/empregado/filtrarGestores/${prefixoNome}`);
    }

    //RHFPP-612 - Atualizar Gestor Solicitante
    filtrarGestorPorMatricula(matricula) {
        return http.get("/" + this.serviceName + "/gestor-solicitante/" + matricula);
    }

    getByCPFOrMatricula(input, callback) {
        if (input && input.length === 11) {
            return this.getByCPF(input).then(response => {
                if(response.data) {
                    response.data.cpf = input;
                    return [response.data];
                } else {
                    return [];
                }
            }).catch(error => {
                console.log(error);
                return [];
            });
        } else if(input && ((input.length >= 5 && input.startsWith("0")) || (input.length >= 2 && !input.startsWith("0"))) && input.length <= 10){
            return this.getByMatricula(input).then(response => {
                if(response.data) {
                    return response.data;
                } else {
                    return [];
                }
            }).catch(error => {
                console.log(error);
                return [];
            });
        } else {
            // retornar Promise
            callback(null, {options: [],complete: false});
            return Promise.resolve([]);
        }
    }
    getListaGestorPorMatricula(input, callback) {
        if(input && ((input.length >= 5 && input.startsWith("0")) || (input.length >= 2 && !input.startsWith("0"))) && input.length <= 10){
            return this.getGestoresSolicitantesPorMatricula(input).then(response => {
                if(response.data) {
                    return response.data;
                } else {
                    return [];
                }
            }).catch(error => {
                console.log(error);
                return [];
            });
        } else {
            // retornar Promise
            callback(null, {options: [],complete: false});
            return Promise.resolve([]);
        }
    }

    //RHFPP-612 - Atualizar Gestor Solicitante
    getGestoresSolicitantesPorMatricula(input, callback) {
        if (input && ((input.length >= 5 && input.startsWith("0")) || (input.length >= 2 && !input.startsWith("0"))) && input.length <= 10) {
            return this.filtrarGestorPorMatricula(input).then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return [];
                }
            }).catch(error => {
                console.log(error);
                return [];
            });
        } else {
            // retornar Promise
            callback(null, { options: [], complete: false });
            return Promise.resolve([]);
        }
    }

    listarGestoresAtivosPorMatricula(input, callback) {
        return this.listarGestores(input, callback);
    }

    listarGestoresAtivos(input, callback){
        return this.listarGestores(input, callback);
    }
    listarGestoresIncluindoDesligados(input, callback){
        return this.listarGestores(input, callback, true);
    }

    listarGestores(input, callback, incluiDesligados = false) {
        if (!input) {
            if (typeof callback === "function") {
                callback(null, { options: [], complete: false });
            }
            return Promise.resolve([]);
        }

        const valorPesquisa = input;
        const isMatricula = /^\d{3,}$/.test(valorPesquisa);
        const isNome = valorPesquisa.length >= 3 && !/\d/.test(valorPesquisa);

        if (!isMatricula && !isNome) {
            if (typeof callback === "function") {
                callback(null, { options: [], complete: false });
            }
            return Promise.resolve([]);
        }

        const campo = isMatricula ? "matricula" : "nome";
        const queryParam = `incluiDesligados=${incluiDesligados}&${campo}=${encodeURIComponent(valorPesquisa)}`;

        return this.executarListarGestores(queryParam).then(response => {
            if (response.data) {
                return response.data;
            } else {
                return [];
            }
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    executarListarGestores(queryParam) {
        return http.get("/"+this.serviceName+"/listar-gestores?"+queryParam);
    }   
    
}